<div fxLayout="row" fxLayoutAlign="center center">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{title}}</mat-card-title>
            <mat-card-subtitle>{{subtitle}}</mat-card-subtitle>
        </mat-card-header>
        <img class="panda-party" alt="{{altText}}" src="{{src}}" routerLink="{{link}}">
    </mat-card>
</div>
